import React, { useState } from "react";
import { Box } from "@mui/material";
import RenderTabs from "components/Tabs/Tabs";
import ManageAlerts from "../ManageAlerts";

export const BuilderSettings = () => {
  const [value, setValue] = useState("alertsConfig");

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <RenderTabs
            tabs={[
              // {
              //   key: "generalSettings",
              //   label: "General Settings",
              //   TabComponent: AppConfigUI,
              // },
              {
                key: "alertsConfig",
                label: "Manage Alerts",
                TabComponent: ManageAlerts,
              },
            ]}
            selectedTab={value}
            onTabClick={(newValue) => {
              setValue(newValue);
            }}
          />
        </Box>
      </Box>
    </>
  );
};
export default BuilderSettings;
